
import { useState, useEffect } from "react";
import Banner from "../../../assets/images/ReferAndEarnBannerNew.png";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from "utlis/commonfunctions";
import axios from "axios";
import Loader from "../../Features/PrepaidActivation/Components/loader";
import swal from 'sweetalert';

const SERVER_URL = process.env.REACT_APP_API_URL;
const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

const ReferAndEarn = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [initialData, setInitialData] = useState("");
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true); 
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [inactive, setInactive] = useState(false);

  useEffect(() => {
    handleInitialLoad();
  }, []);

  const handleInitialLoad = async () => {
    setInitialLoading(true);
    try {
      const header = await getApiHeader();
      const response = await axios.get(`${SERVER_URL}refer-earn/get_refer_earn_details`, {
        headers: header,
      });
      setInitialData(response?.data?.data?.data);
    } catch (error) {
      setInactive(error?.response?.data?.message);
      console.error("Error fetching data:", error);
    }
    setInitialLoading(false);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Recipient's Name is required";
    if (!email.trim()) newErrors.email = "Recipient's Email is required";
    if (!isChecked) newErrors.isChecked = "You must agree before submitting";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setFormSubmitting(true);
    try {
      const payload = {
        recepient_email: email,
        recepient_name: name,
        recepient_message: message,
      };
      const header = await getApiHeader();
      const response = await axios.post(
        `${SERVER_URL}refer-earn/store_refer_earn_details_log`,
        payload,
        {
          headers: header,
        }
      );

      if (response.status === 200) {
        swal("", response.data.message, "success").then(() => {
          setEmail("");
          setName("");
          setMessage("");
          setIsChecked(false);
          setErrors({});
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response) {
        setErrors({
          apiError:
            error.response.data.message ||
            "An error occurred, please try again.",
        });
        swal(
          "Error",
          error.response.data.message || "Something went wrong. Please try again.",
          "error"
        );
      }
    }
    setFormSubmitting(false);
  };

  const downloadPdf = async () => {
    try {
      const response = await axios.get("https://ExampleAPI.com/getFile", {
        responseType: "blob",
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", `bill_${User_Id}_${date}.pdf`);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="refer-earn-container refer-earn">
        {initialLoading ? (
          <Loader className="refer-earn-loader" />
        ) : (
          <div className="refer-earn-box">
            {initialData.qr_code&&  
            <div className="refer-earn-banner" style={{ position: "relative", display: "inline-block" }}>
              <img
                src={Banner}
                alt="Referral Banner"
                className="refer-earn-banner-image"
              />
              
                <img
                  src={initialData?.qr_code}
                  alt="QR Code"
                  className="refer-earn-qr-code"
                />
              
            </div>
}

            <div className="refer-earn-content">
              <h4 className="refer-earn-title">Refer & Earn More!</h4>
              {inactive ? (
                <p className="refer-earn-description">
                  You are not eligible for the Refer & Earn offer.
                </p>
              ) : (
                <>
                  <p className="refer-earn-description">
                    Refer your customers to Telsim. <br />
                    Every time they use your referral code, you earn more!
                  </p>

                  <a
                    href={initialData?.shop_qr_code}
                    className="refer-earn-download-qr-button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download QR Code
                  </a>

                  <h6 className="refer-earn-subtitle">
                    Send Your Unique Referral Code via Email:
                  </h6>
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="refer-earn-form-group">
                      <input
                        type="text"
                        name="refer_name"
                        id="refer_name"
                        maxLength="50"
                        placeholder="Recipient's Name"
                        className="refer-earn-input"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          setErrors((prev) => ({ ...prev, name: "" }));
                        }}
                      />
                      {errors.name && (
                        <p className="refer-earn-error-message">{errors.name}</p>
                      )}

                      <input
                        type="email"
                        name="email"
                        id="email"
                        maxLength="50"
                        placeholder="Enter recipient's email"
                        className="refer-earn-input"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrors((prev) => ({ ...prev, email: "" }));
                        }}
                      />
                      {errors.email && (
                        <p className="refer-earn-error-message">{errors.email}</p>
                      )}

                      <textarea
                        className="refer-earn-input refer-earn-textarea"
                        id="message"
                        rows="4"
                        placeholder="Your Message (Optional)"
                        maxLength={200}
                        name="message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>

                    <div className="refer-earn-consent-container">
                      <input
                        type="checkbox"
                        id="consent"
                        checked={isChecked}
                        onChange={() => {
                          setIsChecked(!isChecked);
                          setErrors((prev) => ({ ...prev, isChecked: "" }));
                        }}
                      />
                      <label htmlFor="consent" className="refer-earn-consent-label">
                        I confirm I have obtained consent to share this information with Telsim.
                      </label>
                    </div>
                    {errors.isChecked && (
                      <p className="refer-earn-error-message">{errors.isChecked}</p>
                    )}

                    <button
                      className="refer-earn-button"
                      type="submit"
                      disabled={formSubmitting}
                    >
                      {formSubmitting ? "Sending..." : "Send Telsim Offer"}
                    </button>

                    <p className="refer-earn-link">
                      Or share your personal link: <br />

                      {/* <a target="blank" className="refer-earn-link-tag" href={`${WEBSITE_URL}${initialData?.qr_short_link}`} rel="noopener noreferrer">
                        {`${WEBSITE_URL}${initialData?.qr_short_link}`}   {initialData?.qr_short_link===null? initialData?refer_utm_link : {`${WEBSITE_URL}${initialData?.qr_short_link}`}   }
                      </a> */}


                          <a
                            target="_blank"
                            className="refer-earn-link-tag"
                            href={
                              initialData?.qr_short_link
                                ? `${WEBSITE_URL}${initialData.qr_short_link}`
                                :initialData?.refer_utm_link
                            }
                            rel="noopener noreferrer"
                          >
                            {initialData?.qr_short_link
                              ? `${WEBSITE_URL}${initialData.qr_short_link}`
                              :initialData?.refer_utm_link}
                          </a>



                    </p>

                    <p className="refer-earn-terms">*Terms and conditions apply.</p>
                  </form>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ReferAndEarn;


